import React, { useEffect, useState } from 'react';
import { AuthGuard } from './components/AuthGuard';
import { AppLayout } from './components/AppLayout';
import { AuthProvider } from './context/AuthContext';
import { DashboardPage } from './pages/DashboardPage';
import { MembersPage } from './pages/MembersPage';
import { EventsPage } from './pages/EventsPage';
import { AttendancePage } from './pages/AttendancePage';
import { PassesPage } from './pages/PassesPage';
import { UsersPage } from './pages/UsersPage';
import { DrawingPage } from './pages/DrawingPage';
import { logger } from './utils/logger';

const PAGE_KEYS = ['dashboard', 'members', 'events', 'passes', 'users', 'drawing', 'attendance'] as const;

export type PageKey = (typeof PAGE_KEYS)[number];

const getHash = (): PageKey => {
  const hash = window.location.hash.replace('#', '');
  return PAGE_KEYS.includes(hash as PageKey) ? (hash as PageKey) : 'dashboard';
};

const CurrentPage: React.FC<{ currentPage: PageKey }> = ({ currentPage }) => {
  if (currentPage === 'members') return <MembersPage />;
  if (currentPage === 'events') return <EventsPage />;
  if (currentPage === 'passes') return <PassesPage />;
  if (currentPage === 'users') return <UsersPage />;
  if (currentPage === 'drawing') return <DrawingPage />;
  if (currentPage === 'attendance') return <AttendancePage />;
  return <DashboardPage />;
};

export const App: React.FC = () => {
  const [currentPage, setCurrentPage] = useState<PageKey>(getHash);

  useEffect(() => {
    logger.info('Admin portal mounted');
  }, []);

  useEffect(() => {
    const onHashChange = () => setCurrentPage(getHash());
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  return (
    <AuthProvider>
      <AuthGuard>
        <AppLayout currentPage={currentPage}>
          <CurrentPage currentPage={currentPage} />
        </AppLayout>
      </AuthGuard>
    </AuthProvider>
  );
};
